<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt width="25" height="25" />
      <p class="title-bk">体験ID登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'student' }">戻る</router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitForm)" ref="form">
          <table class="table table-form">
            <tbody>
              <ChoiceField
                v-model="corporationChoiceFieldMultiModels"
                extraRules="required_select"
                label="法人名（法人ID）"
                placeholder="選択して下さい"
                resourceType="corporation"
                modelFieldName="corporation"
                :choiceDisable="loggedInAsCorporation || loggedInAsBrand || loggedInAsSchool || loggedInAsTeacher"
                :childFieldNames="['brand', 'school', 'course', 'tamaiClass']"
                :formData="trialStudent"
              />
              <ChoiceField
                v-model="brandChoiceFieldMultiModels"
                extraRules="required_select"
                label="ブランド名（ブランドID）"
                placeholder="選択して下さい"
                resourceType="brand"
                modelFieldName="brand"
                :childFieldNames="['school', 'course', 'tamaiClass']"
                :choiceDisable="
                  loggedInAsBrand || loggedInAsSchool || loggedInAsTeacher || isEmpty(trialStudent.corporation)
                "
                :formData="trialStudent"
              />

              <ChoiceField
                v-model="schoolChoiceFieldMultiModels"
                extraRules="required_select"
                label="教場名（教場ID）"
                placeholder="選択して下さい"
                resourceType="school"
                modelFieldName="school"
                :childFieldNames="['tamaiClass']"
                :choiceDisable="loggedInAsSchool || isEmpty(trialStudent.brand)"
                :formData="trialStudent"
              />
              <ChoiceField
                v-model="courseChoiceFieldMultiModels"
                extraRules="required_select"
                label="コース名（コースID）"
                placeholder="選択して下さい"
                resourceType="course"
                modelFieldName="course"
                :childFieldNames="['tamaiClass']"
                :choiceDisable="isEmpty(trialStudent.brand)"
                :formData="trialStudent"
              />
              <ChoiceField
                v-model="tamaiClassChoiceFieldMultiModels"
                extraRules="required_select"
                label="クラス名（クラスID）"
                placeholder="選択して下さい"
                resourceType="class"
                modelFieldName="tamaiClass"
                :choiceDisable="
                  isEmpty(trialStudent.brand) || isEmpty(trialStudent.school) || isEmpty(trialStudent.course)
                "
                :formData="trialStudent"
              />
              <SelectField
                label="利用教材"
                extraRules="required_select"
                inputClass="col-lg-8"
                placeholder="選択してください"
                :options="trialTeachingMaterialOptions"
                optionValue="code"
                optionLabel="name"
                v-model="trialStudent.trialTeachingMaterialCode"
              />
              <TextField
                v-model="trialStudent.trialCourseCode"
                label="専用体験コード"
                placeholder="半角英数字8文字以上で入力してください"
                extraRules="required|dedicated_trial_code"
                v-if="isTrialCode"
              />
              <TextField
                type="number"
                v-model="trialStudent.numOfTrialAccounts"
                label="ID発行数（最大100まで）"
                extraRules="required|digits_between_1_100"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-red" :disabled="isProcessing">発行</button>
          </div>
        </form>
      </ValidationObserver>
      <PopUpHolder
        ref="error_popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="閉じる"
        @greenClick="errorConfirmed"
      >
        <template v-slot:header>エラー</template>
        <template v-slot:body>専用体験コードが間違っています</template>
      </PopUpHolder>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="閉じる"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>体験ID登録</template>
        <template v-slot:body>
          <div class="form-inline">完了しました！</div>
          <div class="form-inline">作成した体験ID数：{{ studentSize }}</div>
          <div class="form-inline">利用教材：{{ currentTrialTeachingMaterial }}</div>
          <div class="tab-content">
            <div id="table-1" class="tab-pane active">
              <div class="table-wrapper-scroll-y my-custom-scrollbar">
                <b-table ref="student-popup-table" responsive sticky-header :items="students" :fields="fields">
                  <template v-slot:cell(trialExpirationDatetime)="row">
                    {{ trialExpirationDatetimePresent(row.value) }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import ChoiceField from '@/components/forms/ChoiceField.vue';
import TextField from '@/components/forms/TextField.vue';
import SelectField from '@/components/forms/SelectField.vue';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
  basicTamaiClassNameIdPresent,
  basicDate,
} from '@/presenters/fields';
import { filterTeachingMaterialsByProducts } from '@/utils/teaching_material_helpers';

export default {
  data() {
    var fields = [
      {
        key: 'uid',
        label: '体験ID',
        sortable: true,
        thAttr: { width: 150 },
      },
      {
        key: 'password',
        label: '初期パスワード',
        sortable: true,
        thAttr: { width: 200 },
      },
      {
        key: 'trialExpirationDatetime',
        label: '有効期限',
        sortable: true,
        thAttr: { width: 200 },
      },
    ];
    return {
      trialStudent: {},
      fields: fields,
      isProcessing: false,
    };
  },
  components: {
    ValidationObserver,
    PopUpHolder,
    ChoiceField,
    TextField,
    SelectField,
  },
  computed: {
    corporationChoiceFieldMultiModels() {
      return basicCorporationNameIdPresent(this.trialStudent.corporation);
    },
    brandChoiceFieldMultiModels() {
      return basicBrandNameIdPresent(this.trialStudent.brand);
    },
    schoolChoiceFieldMultiModels() {
      return basicSchoolNameIdPresent(this.trialStudent.school);
    },
    courseChoiceFieldMultiModels() {
      return basicCourseNameIdPresent(this.trialStudent.course);
    },
    tamaiClassChoiceFieldMultiModels() {
      return basicTamaiClassNameIdPresent(this.trialStudent.tamaiClass);
    },
    isTrialCode() {
      return this.trialStudent.trialTeachingMaterialCode == 'trialCode';
    },
    studentSize() {
      return this.totalStudents;
    },
    currentTrialTeachingMaterial() {
      if (this.trialStudent.trialTeachingMaterialCode) {
        return this.getTrialTeachingMaterialByCode(this.trialStudent.trialTeachingMaterialCode).name;
      } else {
        return null;
      }
    },
    trialTeachingMaterialOptions() {
      if (this.trialStudent.corporation) {
        const allTrialTeachingMaterials = this.trialTeachingMaterials;
        const userProducts = this.trialStudent.corporation.figuredProducts;
        const userTrialTeachingMaterials = filterTeachingMaterialsByProducts(allTrialTeachingMaterials, userProducts);
        const trialCode = allTrialTeachingMaterials.find((teachingMaterial) => {
          return teachingMaterial.code === 'trialCode';
        });
        if (trialCode) userTrialTeachingMaterials.push(trialCode);
        return userTrialTeachingMaterials;
      } else {
        return [];
      }
    },
    ...mapState({
      editingStudent: (state) => state.student.editingStudent,
      trialTeachingMaterials: (state) => state.trial_teaching_material.trialTeachingMaterials,
    }),
    ...mapState({
      students: (state) => state.student_trial_registration.students,
    }),
    ...mapState(['corporation']),
    ...mapState(['brand']),
    ...mapState(['school']),
    ...mapState(['teacher']),
    ...mapState('form', ['prevFormData']),
    ...mapGetters('student_trial_registration', ['totalStudents']),
    ...mapGetters('trial_teaching_material', ['getTrialTeachingMaterialByCode']),
    ...mapGetters('auth', ['loggedInAsCorporation', 'loggedInAsBrand', 'loggedInAsSchool', 'loggedInAsTeacher']),
  },
  created() {
    this.trialStudent = this.createFreshStudentObject();
  },
  methods: {
    createFreshStudentObject() {
      if (this.prevFormData) {
        // Reset content of pulldown when reselecting corporation.
        this.prevFormData.trialTeachingMaterialCode = '';
        this.$logger.debug('Restoring previous form data', this.prevFormData);
        return this.prevFormData;
      } else {
        let newTrialStudent = {
          corporation: null,
          brand: null,
          school: null,
          course: null,
          tamaiClass: null,
          trialTeachingMaterialCode: '',
          trialCourseCode: null,
          numOfTrialAccounts: '1',
          password: 'z000',
        };

        if (this.loggedInAsCorporation) {
          newTrialStudent.corporation = this.corporation.corporation;
        }

        if (this.loggedInAsBrand) {
          newTrialStudent.corporation = this.brand.brand.corporation;
          newTrialStudent.brand = this.brand.brand;
        }

        if (this.loggedInAsSchool) {
          newTrialStudent.corporation = this.school.school.corporation;
          newTrialStudent.brand = this.school.school.brand;
          newTrialStudent.school = this.school.school;
        }

        if (this.loggedInAsTeacher) {
          newTrialStudent.corporation = this.teacher.teacher.corporation;
          newTrialStudent.brand = this.teacher.teacher.brand;
        }

        return newTrialStudent;
      }
    },
    trialExpirationDatetimePresent(field) {
      return basicDate(field);
    },
    submitForm() {
      this.isProcessing = true;
      this.$logger.debug('Started Adding trialStudent: ' + JSON.stringify(this.trialStudent));
      const trialTeachingMaterial = this.trialTeachingMaterials.find((material) => {
        return material.code == this.trialStudent.trialTeachingMaterialCode;
      });
      this.trialStudent.teachingMaterialCode = trialTeachingMaterial.teachingMaterialCode || null;
      this.finishEditingTrialStudent(this.trialStudent)
        .then(() => {
          this.$refs['popup_holder'].show();
        })
        .catch(() => {
          this.isProcessing = false;
          this.$refs['error_popup_holder'].show();
        });
    },
    errorConfirmed() {
      this.$logger.debug('Error Popup done');
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'student' });
    },
    ...mapActions('student_trial_registration', ['finishEditingTrialStudent']),
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  padding-bottom: 6px;
}
.section-subtitle {
  padding-bottom: 12px;
}
form.inline-form {
  display: inline-block;
}
.btn-confirm {
  margin-left: 0px;
}
</style>
